import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { ThemeProvider } from './Context/ThemeContext';
import App from './App';
import './index.css';
import customTheme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ChakraProvider theme={customTheme}>
        <App />
      </ChakraProvider>
    </ThemeProvider>
  </React.StrictMode>
);
